<template>
  <div class="page-container">
    <div v-if="tips.redTip" class="color-header">
      <div class="color-item">
        <i class="color red"></i>
        <span>{{ tips.redTip }}</span>
      </div>
      <div class="color-item">
        <i class="color green"></i>
        <span>{{ tips.greenTip }}</span>
      </div>
      <div class="color-item">
        <i class="color yellow"></i>
        <span>{{ tips.yellowTip }}</span>
      </div>
    </div>
    <div class="page-container-inner">
      <div class="page-outline">
        <div v-if="questionPageList.length && questionList.length" @click="getPage(item.pageNumber)"
             style="cursor: pointer"
             :class="{'pageItem': true,'active': item.pageNumber == questionList[0].pageNumber}"
             v-for="(item,index) in questionPageList" :key="index">
          第{{ item.pageNumber }}页 <span v-if="item.pageRemark">({{ item.pageRemark }})</span>
        </div>
      </div>
      <div class="question-list" id="questionList" v-loading="!showList" element-loading-text="拼命加载中"
           element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-spinner="el-icon-loading">
        <div class="quesion-root" v-if="questionList.length && showList ">
<!--          <div v-if="questionDisabled" class="mask"></div>-->
          <!--                      <div :class="{'question-item-bd': item.isShow}" v-for="(item,index) in questionList" :key="index">-->
          <div :class="{'question-item-bd': item.isShow}" v-show="item.isShow" v-for="(item,index) in questionList" :key="item.id">
            <div class="quality-result" v-if="item.isShow && $route.path != '/studyPage'">
              <i @click="queryRuleByCondition(item)" class="el-icon-question "></i>
              <i class="el-icon-circle-close" style="color: red"
                 v-if="!item.isRightAnd && abnormalType.indexOf($route.query.abnormal) == -1"></i>
              <i v-else></i>
            </div>
            <div style="position: relative">
              <div v-if="questionDisabled" class="mask"></div>
              <question-single :currentPage="currentPage" :patient-id="patientId" @setJump="setJump"
                               @clearJump="clearJump" :ref="item.id"
                               :question-list="questionList"
                               :displaySetting="item.displayNumber"
                               :jumpSetting="item.jumpNumber" v-if="item.type == 1"
                               :question="item"></question-single>
              <question-multiple :currentPage="currentPage" :patient-id="patientId" :ref="item.id"
                                 :question-list="questionList"
                                 :displaySetting="item.displayNumber"
                                 :jumpSetting="item.jumpNumber" v-else-if="item.type == 2"
                                 :question="item"></question-multiple>
              <question-drop-down :currentPage="currentPage" :patient-id="patientId" :ref="item.id"
                                  :question-list="questionList"
                                  :displaySetting="item.displayNumber"
                                  :jumpSetting="item.jumpNumber" v-else-if="item.type == 3"
                                  :question="item"></question-drop-down>
              <question-completion :currentPage="currentPage" :patient-id="patientId" :ref="item.id"
                                   v-else-if="item.type == 4"
                                   :question="item"></question-completion>
              <question-time-select :currentPage="currentPage" :question-list="questionList" :patient-id="patientId"
                                    :ref="item.id"
                                    v-else-if="item.type == 8"
                                    :question="item"></question-time-select>
              <question-para :currentPage="currentPage" :ref="item.id" v-else-if="item.type == 6"
                             :question="item"></question-para>
              <question-scale :currentPage="currentPage" :patient-id="patientId" @setJump="setJump" @clearJump="clearJump"
                              :ref="item.id"
                              :question-list="questionList"
                              :displaySetting="item.displayNumber"
                              :jumpSetting="item.jumpNumber" v-if="item.type == 9"
                              :question="item"></question-scale>
              <question-time-rule :currentPage="currentPage"  :followupTaskId="taskId" :patient-id="patientId"
                                  @setJump="setJump"
                                  @clearJump="clearJump"
                                  :ref="item.id"
                                  :question-list="questionList"
                                  :displaySetting="item.displayNumber"
                                  :jumpSetting="item.jumpNumber" v-else-if="item.type == 10"
                                  :question="item"></question-time-rule>
              <question-number-value :currentPage="currentPage"  :followupTaskId="taskId" :patient-id="patientId"
                                     @setJump="setJump"
                                     @clearJump="clearJump"
                                     :ref="item.id"
                                     :question-list="questionList"
                                     :displaySetting="item.displayNumber"
                                     :jumpSetting="item.jumpNumber" v-else-if="item.type == 11"
                                     :question="item"></question-number-value>
            </div>
            <div v-if="$route.path != '/studyPage'">
              <!--               <div v-if="item.qualityResult && item.qualityResult.ruleInfo.length && $route.query.abnormal != 2" style="color:#ccc;" v-html="item.qualityResult.ruleInfo.find(it => it.ruleType == 3).ruleDesc"></div>-->
              <div v-if="abnormalType.indexOf($route.query.abnormal) == -1" class="answer-remark">
                {{ item.answerQcInfoRemark }}
              </div>
              <div v-if="item.showQualityResult && ((item.qualityResult && item.qualityResult.ruleInfo.length) || (item.questionAnnotations &&item.questionAnnotations.length))"
                   class="qualityDetail ql-editor">
                <div v-if="item.qualityResult.ruleInfo.length" v-for="(_it,_ind) in item.qualityResult.ruleInfo">
                  <div style="color: #248cfa">{{ ruleInfoDict[_it.ruleType * 1 - 1] }}</div>
                  <div v-if="_it.ruleDesc" style="color:#6C6C6C;font-size: 13px" v-html="_it.ruleDesc"></div>
                  <div v-else style="color:#6C6C6C;font-size: 13px">无</div>
                </div>
                <div v-if="item.questionAnnotations && item.questionAnnotations.length">
                  <div style="font-size: 14px;color: red;margin-top: 10px;font-weight: 700;">此题出错原因：</div>
                  <div style="font-size: 14px;margin-top: 5px;" v-for="(item,index) in item.questionAnnotations" :key="index">{{index+ 1}}.{{item}}</div>
                </div>
              </div>
              <div v-else-if="item.showQualityResult && item.questionAnnotations &&  !item.questionAnnotations.length && item.qualityResult && !item.qualityResult.ruleInfo.length">
                <span style="color:#6C6C6C;">无</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <h1>题目已答完</h1>
        </div>
        <!--        <div class="btn-list">-->
        <!--          <button v-if="pageHistoryList.length" class="submitBtn" @click="getPrevPage">上一页</button>-->
        <!--          <button v-if="questionList.length" class="submitBtn" @click="getNextPage">下一页</button>-->
        <!--        </div>-->
      </div>
    </div>
    <el-backtop target=".question-list" :bottom="100">
      <div
          style="{
          height: 100%;
          width: 100%;
          background-color: #f2f5f6;
          box-shadow: 0 0 6px rgba(0,0,0, .12);
          text-align: center;
          line-height: 40px;
          color: #1989fa;
        }"
      >
        <i class="el-icon-top"></i>
      </div>
    </el-backtop>
  </div>
</template>
<script>
import questionSingle from './questionItemByType/question-single'
import questionMultiple from './questionItemByType/question-Multiple'
import questionDropDown from './questionItemByType/question-dropDown'
import questionTimeSelect from './questionItemByType/questionTimeSelect'
import questionCompletion from './questionItemByType/question-completion'
import questionPara from './questionItemByType/question-para'
import qsDetailDB from "@src/assets/qsList/indexDB.js"
import questionScale from './questionItemByType/question-scale'
import questionTimeRule from "./questionItemByType/question-timeRule";
import questionNumberValue from "./questionItemByType/question-numberValue";
import {
  RestNewFollowupQuestionListServiceQueryPageAndQuestionListForOnePageNew,
  RestNewFollowupQuestionListServiceAddPatientAnswerInfo,
  RestNewFollowupQuestionListServiceGetTips
} from "@src/assets/js/api.js"

import {mapGetters, mapMutations} from 'vuex'

export default {
  name: 'question-root-node',
  props: {
    // questionList: { required: true }
    patientId: {required: true},
    infoId: {required: true},
    taskId: {required: false},
    questionDisabled: {
      default() {
        return false
      }
    },
    isRecord :{
      required: false,
      default() {
        return false
      }
    }
    // followupPatientId:{required: true}
  },
  data() {
    return {
      currentPage: 1,
      ruleInfoDict: ['话术提示', '填写规范', '评分说明'],
      tips: {},
      qsLoading: false,
      showList: false,
      prevErrComponent: null,
      questionList: [],
      questionPageList: [],
      nextPage: null,
      prevPage: 0,
      pageHistoryList: [],
      statusId: null,
      timeer: null,
      abnormalType: ['2', '3', '4', '6', '100']
    }
  },
  components: {
    questionSingle,
    questionMultiple,
    questionDropDown,
    questionTimeSelect,
    questionCompletion,
    questionPara,
    questionScale,
    questionTimeRule,
    questionNumberValue
  },
  mounted() {
    this.__init()
  },
  computed: {
    ...mapGetters([
      'userid',
      'questionId',
      'getTaskCenterId',
    ]),

    questionPageListShow() {
      return this.questionList.filter(item => item.isShow)
    }
  },

  destroyed() {
    console.log(this.$route.path);
    if(this.$route.path != '/wrongQuestionDetail' && this.$route.path != '/wrongQuestionList') {
      this.bantchSaveAnswer()
    }
  },
  beforeDestroy() {
    console.log(this.$route.path);
    clearInterval(this.timeer)
  },
  watch: {
    nextPage(newValue, oldValue) {
      qsDetailDB.listenerNextPage({
        pageNumber: newValue,
        id: this.questionId,
        patientId: this.patientId
      })
    },
    patientId: { // 监听路由的参数变化
      handler(val,oldVal) { // 数据变化更新数据
        console.log("下一位患者VAL", val)
        if(oldVal && oldVal!= val) {
          this.refresh();
        }
      },
      immediate: true // 立即执行
    }
  },
  methods: {
    ...mapMutations([
      'setCurrentPage'
    ]),
    refresh() {
      this.showList = false
      this.__init()
      this.timeer = setInterval(() => {
        this.getCurrentQuestion()
      }, 10000)
    },
    __init() {
      this.setCurrentPage(1)
      console.log('indexDB', qsDetailDB);
      qsDetailDB.addQsID({patientId: this.patientId, questionPageList: [], errorQuestion: []})
      let params = {
        id: this.questionId,
        pageNumber: this.prevPage + 1,
        patientId: this.patientId
      }
      console.log('paient===>', {
        followupPatientId: this.patientId,
        questionnaireNewId: this.questionId
      })
      qsDetailDB.insertPageListById({
        abnormal: this.abnormalType.indexOf(this.$route.query.abnormal) == -1,
        pageNumber: 1,
        id: this.questionId,
        patientId: this.patientId,
        followupPatientInfoId: this.infoId,
        isQuestionnaireList: false
      }, (source) => {
        this.questionList = []
        this.$nextTick(() => {
          this.questionList = source.questionList
          this.nextPage = this.questionList[0].pageNumber + 1
          var errorQuestion = source.errorQuestion
          if (errorQuestion.length == 1 && errorQuestion[0].title.indexOf('最后') != -1) {
            this.lastPage()
          }
          this.showList = true
        })
      })
      this.getAllQuestionList()
      this.$store.dispatch('addPatientQuestionAnswer', {
        followupPatientId: this.patientId,
        questionnaireNewId: this.questionId
      })
          .then(res => {
            console.log(res)
            this.statusId = res.retValue.id
          })
      this.$store.dispatch('fillTelQuestionnaireNewAnswer', {
        followupPatientId: this.patientId,
        questionnaireNewId: this.questionId
      })
          .then(res => {
            console.log(res)
            if (params.pageNumber != 1) {
              this.getQuestionList(params)
            }
          })
      this.getTipsAsync({id: this.questionId})
          .then(res => {
            this.tips = res.retValue
          })
    },

    getQuestionList(p) {
      p.abnormal = this.abnormalType.indexOf(this.$route.query.abnormal) == -1,
          this.qsLoading = true
      qsDetailDB.getPageListById(p, (source) => {
        this.questionList = []
        this.questionList = source.questionList
        this.nextPage = this.questionList[0].pageNumber + 1
        var errorQuestion = source.errorQuestion
        if (errorQuestion.length == 1 && errorQuestion[0].title.indexOf('最后') != -1) {
          console.log('跳转最后页')
          this.lastPage()
        }
        this.qsLoading = false
        this.showList = true
      })

    },
    getCurrentQuestion() {
      this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupQuestionListServiceGetUpdateTips',
        params: {
          questionnaireId: this.questionId,
          seatId: sessionStorage.getItem('userid')
        }
      }).then(async res => {
        console.log(res);
        if (res.status == 0 && res.retValue.length) {
          for (let i = 0; i < res.retValue.length; i++) {
            await new Promise(((resolve) => {
              setTimeout(() => {
                this.$notify({
                  title: '提示',
                  message: `第${res.retValue[i].pageNumber}页${res.retValue[i].serialNumber}题有质控规则更新`,
                  duration: 5000,
                  onClose: () => {
                    this.gotoQuestion(res.retValue[i])
                  }
                });
                resolve()
              }, 500)
            }))
          }
        }
      })
    },
    gotoQuestion(val) {
      console.log(val);
      this.updateIsRead({
        ruleId: val.id,
        seatId: sessionStorage.getItem('userid')
      })
      if (val.pageNumber == this.questionList[0].pageNumber) {
        this.jumpQuestion(val)
      } else {
        // this.getPage(val.pageNumber)
        //     .then(() => {
        //       setTimeout(() => {
        //         this.jumpQuestion(val)
        //       },3000)
        //     })
      }


    },
    jumpQuestion(val) {
      let currentQuestion = this.questionList.find(it => it.serialNumber == val.serialNumber)
      console.log(currentQuestion);
      this.$refs[currentQuestion.id][0].$el.classList.add('current-select-question')
      setTimeout(() => {
        this.$refs[currentQuestion.id][0].$el.classList.remove('current-select-question')
      }, 1000)
      this.$refs[currentQuestion.id][0].$el.scrollIntoView()
    },
    updateIsRead(p) {
      this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupQuestionListServiceUpdateIsRead',
        params: {
          ruleId: p.ruleId,
          seatId: p.seatId
        }
      }).then(() => {
      })
    },
    lastPage() {
      this.$store.dispatch('updatePateintQuestionAnswer', {
        finish: 0,
        followupPatientId: this.patientId,
        id: this.statusId,
        questionnaireNewId: this.questionId
      })
          .then(res => {
            console.log(res)
          })
    },
    setJump(val) {
      this.nextPage = val
    },
    clearJump() {
      this.nextPage = this.questionList[0].pageNumber + 1
    },
    questionHandle(question) {
      if (question.type) {
        question.completeConfig = question.completeConfig == '' ? {
          'completeTextArr': [{'text1': '', 'text2': ''}],
          'completeType': 'text',
          'maxLength': null
        } : JSON.parse(question.completeConfig)
        question.bingTimeId = question.bingTimeId ? JSON.parse(question.bingTimeId) : null
        question.timeConfigArr = question.timeConfigArr ? JSON.parse(question.timeConfigArr) : [{
          type: '',
          withBingId: '',
          value: ''
        }]
        question.displayConfig = question.displayConfig == '' ? {'displaySettingArr': []} : JSON.parse(question.displayConfig)
        question.scaleConfig = question.scaleConfig == '' ? [] : JSON.parse(question.scaleConfig)
        question.jumpConfig = question.jumpConfig == '' ? {'jumpSettingArr': []} : JSON.parse(question.jumpConfig)
        question.displayNumber = question.displayNumber == '' ? [] : JSON.parse(question.displayNumber)
        question.jumpNumber = question.jumpNumber == '' ? [] : JSON.parse(question.jumpNumber)
        question.dateCycle = this.getBoolean(question.dateCycle)
        question.tipColor = question.tipColor || null
        question.isFirst = this.getBoolean(question.isFirst)
        question.isMust = this.getBoolean(question.isMust)
        question.isShow = this.getBoolean(question.isShow)
        question.manangerActive = this.getBoolean(question.manangerActive)
        question.seqDisabled = this.getBoolean(question.seqDisabled)
        question.paragraphConfig = question.paragraphConfig == '' ? "" : JSON.parse(question.paragraphConfig)
        question.manangerActive = false
        if (question.answerInfo) {
          if (this.isJSON(question.answerInfo)) {
            question.value = JSON.parse(question.answerInfo)
            // question.isShow = true
          } else {
            question.value = question.answerInfo
            // question.isShow = true
          }
        } else {
          question.value = ''
        }
        question.options = question.optionsInfoRespList
      }
      return question
    },
    isJSON(str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str)
          if (typeof obj == 'object' && obj) {
            return true
          } else {
            return false
          }

        } catch (e) {
          console.log('error：' + str + '!!!' + e)
          return false
        }
      }
      console.log('It is not a string!')
    },
    getBoolean(num) {
      return num == 1 ? false : true
    },


    getAllQuestionList() {
      this.$store.dispatch('getQuestionnairePageList', {questionId: this.questionId})
          .then(res => {
            if (res.status == 0) {
              if (res.retValue.length) {
                this.questionPageList = res.retValue
              } else {
                // 获取题目列表为空  初始部分数据
                this.questionPageList = []
              }
            } else {
              this.$message.error(res.desc)
            }
          })
    },

    async getNextPage() {
      this.bantchSaveAnswer()

      var errList = []
      for (var k in this.$refs) {
        if (this.$refs[k][0]) {
          //console.log(this.$refs[k][0].checkIsFill())
          if (Object.prototype.toString.call(this.$refs[k][0].checkIsFill()) === "[object Promise]") {
            var result
            result = await this.$refs[k][0].checkIsFill()
            if (!result) {
              await errList.push(this.$refs[k][0])
            }
          } else {
            if (!this.$refs[k][0].checkIsFill()) {
              //console.log(k)
              await errList.push(this.$refs[k][0])
            }
          }
        }
      }
      console.log("errList===>", errList)
      if (errList.length) {
        if (this.prevErrComponent) {
          this.prevErrComponent.style.border = '2px solid #fff'
        }
        this.prevErrComponent = errList[0].$el
        errList[0].$el.scrollIntoView()
        errList[0].$el.style.border = '2px dashed red'
        this.$message.error(errList[0].question.title + '不符合规则')
      } else {
        this.showList = false
        if (this.prevErrComponent) {
          this.prevErrComponent.style.border = '2px solid #fff'
        }
        qsDetailDB.saveListpage({
          patientId: this.patientId,
          pageNumber: this.questionList[0].pageNumber,
          questionList: this.questionList
        })
        this.getPage(this.nextPage)
        this.pageHistoryList.push(this.questionList[0].pageNumber)
      }
    },

    async getPage(page = null) {
      if(page == this.currentPage || this.qsLoading) {
        console.log(2222);
        return false
      }
      console.log(11111);
      this.currentPage = page
      console.log('pageClick', page)
      if(this.$route.path != '/studyPage' && this.$route.path != '/wrongQuestionDetail') {
        this.bantchSaveAnswer()
      }//
      this.setCurrentPage(page)

      let el = document.getElementById('questionList')
      el.scrollTop = 0
      this.showList = false
      qsDetailDB.saveListpage({
        patientId: this.patientId,
        pageNumber: this.questionList[0].pageNumber,
        questionList: this.questionList
      })
      setTimeout(() => {
        this.getQuestionList({
          patientId: this.patientId,
          id: this.questionId,
          isQuestionnaireList: false,
          followupPatientInfoId: this.infoId,
          pageNumber: page
        })
      }, 200)
    },//
    bantchSaveAnswer() {
      function getValue(item) {
        console.log(item.value);
        if(item.type == 4) {
          return item.value
        }else{
          return JSON.stringify(item.value)
        }
      }
      let questionValue = this.questionPageListShow.map(item => {
        let obj = {}
        if(item.type == 3) {
          if(item.value) {
            obj.answerInfo = JSON.stringify(item.valueAfter)
          }else {
            obj.answerInfo = ""
          }
        }else if([10,11].indexOf(item.type) != -1) {
          obj.answerInfo = item.value && item.value.optionId ? getValue(item) : ""
        }else if(item.type == 2) {
          obj.answerInfo = item.value && item.value.length ? getValue(item) : ""
        }else if(item.type == 8) {
          if(!item.value[0].yearSelect && !item.value[0].monthSelect && !item.value[0].daySelect
            &&!item.value[1].yearSelect && !item.value[1].monthSelect && !item.value[1].daySelect
          ){
            obj.answerInfo = ""
          }else {
            obj.answerInfo =  getValue(item)
          }
        }else {
          obj.answerInfo = item.value ? getValue(item) : ""
        }
        obj.operatorId = sessionStorage.getItem('userid')
        obj.questionInfo = item.id
        obj.questionnaireNewId = this.questionId
        obj.followupPatientId = this.patientId
        obj.questionType = item.type
        obj.sourceType = 2
        obj.isRecord = this.$route.query.abnormal == '5' ? true : false
        return obj
      })
      console.log('isRecord---->', this.isRecord);
      this.$store.dispatch('updateBatchAnswer',{
        list: questionValue,
        taskId: this.taskId || this.getTaskCenterId ||null,
        isRecord: this.isRecord
      }).then( res => {
        console.log(res);
        if(res && res.status == 0 && res.retValue == 'SUCCESS') {
          // this.$message.success('保存成功')
        }else {
          this.$message.error(res.retValue || res.desc)
        }
      })
    },


    async getPrevPage() {
      this.bantchSaveAnswer()
      // this.showList = false
      // qsDetailDB.saveListpage({
      //   patientId: this.patientId,
      //   pageNumber: this.questionList[0].pageNumber,
      //   questionList: this.questionList
      // })
      var deleteNumber = this.pageHistoryList.splice([this.pageHistoryList.length - 1], 1)
      // console.log('deleteNumber', deleteNumber);
      // this.$nextTick(() => {
      // })
      this.getPage(deleteNumber[0])
    },
    async getQuestionByPageAndId(p) {
      let request = new RestNewFollowupQuestionListServiceQueryPageAndQuestionListForOnePageNew()
      request.p_pageNumber = p.pageNumber
      request.p_isQuestionnaireList = false
      request.p_questionnaireNewId = p.id || 227
      request.p_followupPatientId = p.patientId
      await request.send()
      return request.result
    },
    //保存答案
    async saveQuestionAnswer(p) {
      let request = new RestNewFollowupQuestionListServiceAddPatientAnswerInfo()
      request.p_answerInfo = p.answerInfo
      request.p_operatorId = p.operatorId
      request.p_questionInfo = p.questionInfo
      request.p_questionnaireNewId = p.questionnaireNewId
      request.p_followupPatientId = p.patientId
      request.p_questionType = p.questionType
      await request.send()
      return request.result
    },
    async getTipsAsync(p) {
      let request = new RestNewFollowupQuestionListServiceGetTips()
      request.p_id = p.id
      await request.send()
      return request.result
    },
    queryRuleByCondition(item, flag) {
      if (item.showQualityResult) {
        this.$set(item, 'showQualityResult', !item.showQualityResult)
      } else {
        this.$store.dispatch('requestHandler', {
          fn: 'RestNewFollowupQuestionListServiceQueryRuleByCondition',
          params: {
            seatId: sessionStorage.getItem('userid'),
            questionId: item.id,
          }
        }).then(res => {
          this.$set(item, 'qualityResult', res.retValue)
        })
        this.$store.dispatch('requestHandler',{
          fn: 'RestMistakeCollectionControllerGetQuestionAnnotations',
          params: {
            questionnaireId: this.questionId,
            seatId: sessionStorage.getItem('userid'),
            serialNumber: item.serialNumber
          }
        }).then(res => {
          this.$set(item, 'questionAnnotations', res.retValue)
          console.log(1111);
          this.$delete(item, 'showQualityResult')
          this.$set(item, 'showQualityResult', true)
          this.$forceUpdate()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.question-item-bd {
  border: 1px solid #ccc;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 1px 2px 5px 1px #ccc;

}

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.color-header {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 10px;

  .color-item {
    display: flex;
    align-items: center;

    .color {
      margin-right: 20px;
      width: 20px;
      height: 20px;
      display: inline-block;
    }

    .red {
      background-color: red;
    }

    .green {
      background-color: green;
    }

    .yellow {
      background-color: yellow;
    }
  }

}

.page-container {
  height: 100%;
  position: relative;

  .page-container-inner {
    display: flex;
    height: 100%;

    .page-outline {
      flex: .2;

      .pageItem {
        padding: 10px;
        text-align: left;

        &.active {
          background-color: #ccc;
        }
      }
    }

    .question-list {
      height: 100%;
      overflow: auto;
      flex: .8;

      .current-select-question {
        border: 3px solid red;
      }

      .quality-result {
        display: flex;
        justify-content: space-between;
        padding-right: 20px;
        .el-icon-question {
          cursor: pointer;
        }

        .el-icon-circle-close {
          font-weight: 700;
          font-size: 20px;
        }
      }
      .quesion-root {
        position: relative;
      }
      .mask {
        position: absolute;
        z-index: 999;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.03);
      }
      .answer-remark {
        color: red;
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
        margin-bottom: 10px;
      }
    }
  }


}

.btn-list {
  text-align: center;
  padding: 10px 0 20px;
}

.submitBtn {
  width: 30%;
  margin-right: .1 * 100px;
  background-color: #248cfa;
  color: #fff;
  padding: .05 * 100px 0;
  border: none;
  border-radius: .05 * 100px;
}

</style>